<section id="faq" class="faq " >

    <div class="container-fluid " style="margin-top: 9rem;">
        <div class="section-title" data-aos="fade-up" >
            <h2 class="primary">{{'journal_home.frequently_asked_questions'}}</h2>
            <p class="rvh-sub-heading">Find answers to frequently asked questions.</p>

            <div>
                <div class="row faq-item d-flex align-items-stretch text-color" *ngFor="let data of faqArray">
                    <div class="col-lg-5">
                        <i class="ri-question-line"></i>
                        <p [innerHTML]="data.faqQuestion"></p>
                    </div>
                    <div class="col-lg-7">
                        <p [innerHTML]="data.faqAnswer"></p>
                    </div>
                </div>
                
            </div>
        </div>

    </div>
</section>